
import SubmittedInReview from "../content/Common/Error/SubmittedInReview";
import UnauthorizedError from "../content/Common/Error/UnauthorizedError";
import UnauthorizedPlatinum from "../content/Common/Error/UnauthorizedPlatinum";

const ContentMap = {
    unavailable : [UnauthorizedError,SubmittedInReview,UnauthorizedPlatinum]
};

export {ContentMap};